import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const Summary = ({ stats, lang }) => {
  const itemName = (
    typeof stats.suites === 'number'
      ? lang === 'pt' ? 'testes' : 'tests'
      : lang === 'pt' ? 'validações' : 'validaciones'
  );

  const [failuresText, passesText] = (
    lang === 'pt'
      ? [
        `${stats.failures} dos ${stats.tests} ${itemName} falharam`,
        `${stats.passes} testes passaram ;-)`,
      ]
      : [
        `${stats.failures} de ${stats.tests} ${itemName} fallaron`,
        `${stats.passes} tests pasaron ;-)`,
      ]
  );

  return (
    <ListItem>
      <ListItemText
        primary={stats.failures ? failuresText : passesText}
        secondary={`(${stats.duration}ms)`}
      />
    </ListItem>
  );
};

export default Summary;
